<template>
  <div class="info-container">
    <template v-if="participant">
      <div v-if="compact" :class="['info-container compact', { removed: isRemoved }]">
        {{ participantName }} | {{ getDateTime(fromMillis(timestamp)) }}
      </div>
      <div v-else :class="['info-container', { removed: isRemoved }]">
        <Avatar
          class="avatar"
          :name="displayName"
          :thumb-url="participant.thumbUrl"
          :size="AvatarSize.Small"
          :deleted-at="participant.deletedAt"
        />
        <div class="participant-text-details">
          <FriedH4>{{ participantName }}</FriedH4>
          <FriedParagraph v-if="showTimestamp" :size="ParagraphSize.Small">{{
            getDateTime(fromMillis(timestamp))
          }}</FriedParagraph>
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { AvatarSize, ParagraphSize } from '@getaccept/fried-tofu';
import { DateTime } from 'luxon';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import FileHelper from '../helpers/file.helper';
import Avatar from '../../components/Avatar.vue';
import AvatarHelper from '../../helpers/avatar.helper';

export default defineComponent({
  components: {
    Avatar,
  },
  props: {
    participant: {
      type: Object as PropType<{
        id: string;
        firstName?: string;
        lastName?: string;
        thumbUrl?: string;
        email?: string;
        deletedAt?: number;
      }>,
      default: undefined,
    },
    timestamp: {
      type: Number,
      default: 0,
    },
    compact: {
      type: Boolean,
    },
    showTimestamp: { type: Boolean, default: true },
  },
  setup(props) {
    const displayName = computed(() => AvatarHelper.getDisplayName(props.participant));

    const isRemoved = computed(() => props.participant?.deletedAt || !props.participant?.id);

    const participantName = computed(() => displayName.value || t('dr_chat_removed_participant'));

    return {
      AvatarSize,
      displayName,
      ParagraphSize,
      isRemoved,
      getDateTime: FileHelper.getDateTime,
      fromMillis: DateTime.fromMillis,
      participantName,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '../../scss/removed-participant';

.info-container {
  display: flex;
  align-items: center;

  &.compact {
    padding: var(--spacing-50) 0;
  }
}

.avatar {
  margin-right: var(--spacing-100);
}
</style>
